import React, { useRef, useEffect } from "react";

const MessageForm = ({ text, showMessage, setShowMessage, type, icon: IconComponent, closeCallback }) => {
  const messageRef = useRef(null);

  useEffect(() => {
    let timeout;

    if (showMessage && messageRef.current) {
      timeout = setTimeout(() => {
        if (messageRef.current) {
          messageRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 1000);
    }

    // Limpa o timeout se o componente desmontar ou showMessage mudar
    return () => clearTimeout(timeout);
  }, [showMessage]);

  const status = type === "error" ? "bg-[#FF2E00]" : "bg-quaternaria";
  const button = type === "error" ? "bg-[#A4270C]" : "bg-[#007227]";

  function closeMessage() {
    setShowMessage(false);
    if (closeCallback && typeof closeCallback === "function") closeCallback();
  }

  return (
    <div ref={messageRef} className="scroll-mb-[200px]">
      {showMessage && (
        <div className={`${status} relative mt-6 container`}>
          <div className="py-6 text-center">
            <p className="text-white text-2xl font-bold flex justify-center gap-x-4 items-center">
              {IconComponent && <IconComponent />}
              {text}
            </p>
          </div>
          <button
            type="button"
            className={`${button} p-4 rounded-lg text-white font-bold text-1xl absolute top-3 right-3`}
            onClick={closeMessage}
          >
            Fechar
          </button>
        </div>
      )}
    </div>
  );
};

export default MessageForm;
